import {Observable} from 'rxjs';
import config from '@/common/config';
import {persistedStateUserKey, userVerifiableFields} from '@/store/user';

const sessionCheck = Observable.interval(config.VUE_APP_CHECK_SESSION_INTERVAL_MS);

class UserSessionManager {
    constructor(getStore) {
        this.updaterId = null;
        this.getStore = getStore;
    }

    get $store() {
        return this.getStore();
    }

    attach() {
        window.addEventListener('storage', event => this.relay(event));
    }

    /**
     *
     * @param {Object} currentData - current user data (vuex)
     * @param {Object} updatedData - updated user data (new data from localstorage)
     */
    static isEqualUserData(currentData, updatedData) {
        return userVerifiableFields.every((key) => {
            if (key === 'permissions') {
                // old ui
                if (!currentData.preferences
                    || !currentData.preferences.hashes) {
                    return false;
                }
                return currentData.preferences.hashes.permissions
                    === updatedData.preferences.hashes.permissions;
            }

            return currentData[key] === updatedData[key];
        });
    }

    update(event) {
        if (this.updaterId) {
            clearTimeout(this.updaterId);
        }
        this.updaterId = setTimeout(() => {
            try {
                // the new user data
                const {user} = JSON.parse(event.newValue);
                const current = userVerifiableFields
                    .reduce((memo, key) => ({
                        ...memo,
                        [key]: this.$store.getters[`user/${key}`],
                    }), {});

                if (!UserSessionManager.isEqualUserData(current, user)) {
                    this.$store.dispatch('user/updateUser', user)
                        .then(() => this.$store.dispatch('router/reRender'));
                }
            } catch (e) {
                // do nothing
            }
        }, 100);
    }

    relay(event) {
        if (event.key === persistedStateUserKey) {
            if (
                // the window without the focus
                document.hidden
                && event.newValue
                && event.oldValue
                && (event.newValue !== event.oldValue)
            ) {
                // the user was updated, check and update the data
                this.update(event);
            }
        }
    }
}

export default function subscriptions() {
    new UserSessionManager(() => this.$store).attach();

    sessionCheck.subscribe(() => {
        const isAuth = !this.$store.getters['user/isGuest'];
        const isExpired = this.$store.getters['user/isSessionExpired'];
        const localUser = localStorage.getItem(persistedStateUserKey);
        const hasLocalUser = !!localUser;

        if ((isAuth && isExpired) || !hasLocalUser) {
            // remove user from the store
            this.$store.dispatch('app/logout');
            // redirect user to the login
            /**
             * when user is logout successfully,
             * redirect to login page in permissions-sync plugin
             * after permissions updated
             */
        }
    });
    return {sessionCheck};
}
